module.exports = __webpack_public_path__ + "static/img/16bac.f2ec437.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/16bac.jpg
// module id = zjNe
// module chunks = 1